import { fetchCustomFieldDividers } from '../../services/custom-field-dividers.service'
import { ActionTree } from 'vuex'
import { CustomFieldDividerState } from './custom-field-dividers.types'

export const actions: ActionTree<CustomFieldDividerState, unknown> = {
  async fetchCustomFieldDividers({ commit }) {
    try {
      const res = await fetchCustomFieldDividers()
      commit('SET_ALL_CUSTOM_FIELD_DIVIDERS', res)
    } catch (err) {
      commit('SET_CUSTOM_FIELD_DIVIDERS_LOADING_ERROR', err)
    }
  }
}
